
import { Component, Vue, Watch, Prop, Inject, InjectReactive } from "vue-property-decorator"

import SortTabs from "./SortTabs.vue"

@Component({
	components: {
	}
})
export default class SortTab extends Vue {
	// --- Injection ---

	@InjectReactive("tabControl") private tabsControl!: SortTabs
	@InjectReactive("activeId") private activeId!: string | null

	// --- Props ---

	@Prop()
	public title!: string;

	@Prop()
	public tabKey!: string

	@Prop({ type: Boolean })
	unsortable!: boolean

	@Prop({ type: Boolean, default: true })
	show!: boolean

	@Prop({ type: String, default: null })
	public tooltip!: boolean

	// --- Data ---

	id: string | null = null

	// --- Computed Properties ---

	public get active () {
		return this.activeId !== null && this.activeId === this.id
	}

	// --- Lifecycle Hooks ---

	mounted () {
		if (this.tabsControl) {
			this.id = this.tabsControl.registerTab(this)
		}
	}

	beforeDestroy () {
		if (this.tabsControl) {
			this.tabsControl.unregisterTab(this)
			this.id = null
		}
	}
}

